import React, { useEffect } from "react";
import styles from "./VideoDocument.module.css";
import PuiTypography from "../../../components/elements/PuiTypography";
import { VideoExtraMaterial } from "../../../models/video";
import ShowFileIcon from "./ShowFileIcon";
import { saveAs } from "file-saver";
import {
    GetSlideStockDocument,
    GetVideoDocument,
    ResetDocumentUrl,
} from "../../../store/actions/DocumentActions";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { useInitText } from "../../../components/function/useInitText";

interface VideoDocumentProps {
    documentList: VideoExtraMaterial[];
    contentType: string;
}

export default function VideoDocument({ documentList, contentType }: VideoDocumentProps) {
    const dispatch = useDispatch();

    const { downloadLink } = useSelector((state: AppState) => ({
        downloadLink: state.document.url,
    }));

    const [currentFileName, setCurrentFileName] = useInitText();

    // Documentをダウンロードする。
    const DownloadDocument = (documentIndex: number) => {
        if (contentType?.toLowerCase() === "video") {
            setCurrentFileName(documentList[documentIndex].fileName);
            dispatch(
                GetVideoDocument(
                    documentList[documentIndex].videoId,
                    documentList[documentIndex].fileName
                )
            );
        } else if (contentType?.toLowerCase() === "slidestock") {
            setCurrentFileName(documentList[documentIndex].fileName);
            dispatch(
                GetSlideStockDocument(
                    documentList[documentIndex].videoId,
                    documentList[documentIndex].fileName
                )
            );
        }
    };

    // リンクの取得が完了したら、ダウンロードする。
    useEffect(() => {
        if (downloadLink !== "" && currentFileName !== "") {
            saveAs(downloadLink, currentFileName);
            // ファイル名と資料ダウンロードリンクをリセットする。
            setCurrentFileName("");
            dispatch(ResetDocumentUrl());
        }
        // eslint-disable-next-line
    }, [downloadLink, currentFileName]);

    return (
        <div className={styles.videoMaterials}>
            <div className={styles.header}>
                {/* <div className={styles.icon}> 
                    <PuiTypography color={"white"}> <FileIcon/></PuiTypography> */}
                <div className={styles.materialIcon}>
                    <PuiTypography color={"white"} size={20} bold={true}>
                        Documents
                    </PuiTypography>
                </div>
                {/* </div> */}
                {documentList.length === 0 && (
                    <div style={{  color: "var(--primary-font)", marginTop: "5px" }}>
                        登録されているDocumentはありません
                    </div>
                )}

                {/* <div className={styles.materialCount}>
                    <PuiTypography size={20}>{String(documentList.length)}</PuiTypography>
                </div> */}
            </div>

            <div className={styles.videoMaterialsList}>
                {documentList &&
                    documentList.length > 0 &&
                    documentList.map((document, index) => (
                        <ShowFileIcon
                            key={index}
                            fileName={document.fileName}
                            fileType={document.contentType}
                            isVisibleFileName={true}
                            documentIndex={index}
                            DownloadDocument={DownloadDocument}
                            isWhiteColor={true}
                        />
                    ))}
            </div>
        </div>
    );
}
